import React, { PureComponent } from 'react';
import InternalLink from '../InternalLink/InternalLink';
import { Link } from 'react-router';
import { trackAnalyticsEvent } from '@eb/site-analytics';
import { Illustration } from '@eb/eds-illustration';

import {
    APP_MARKETPLACE_EVENT_CATEGORY,
    CATEGORY_CARD_CLICK,
} from '../../constants/analytics';

import { BASE_APPS_URL } from '../../constants/constants';

export default class CategoriesExploreItem extends PureComponent {
    _handleCategoryClick() {
        const { category } = this.props;

        trackAnalyticsEvent({
            action: CATEGORY_CARD_CLICK,
            category: APP_MARKETPLACE_EVENT_CATEGORY,
            label: category.name,
        });
    }

    render() {
        const { category, IllustrationType } = this.props;
        const categoryLink = `${BASE_APPS_URL}categories/${category.slug}/`;

        return (
            <div className="categories-explore-section--item">
                <div className="categories-explore-section--item__image-container">
                    <Link
                        className="categories-explore-section--item__image"
                        to={categoryLink}
                        onClick={this._handleCategoryClick.bind(this)}
                    >
                        <Illustration
                            type={<IllustrationType />}
                            alt={category.name}
                            height="150px"
                            width="auto"
                        />
                    </Link>
                </div>
                <h3 className="categories-explore-section--item__description eds-text-bl eds-text-weight--heavy">
                    <InternalLink
                        to={categoryLink}
                        style="neutral"
                        onClick={this._handleCategoryClick.bind(this)}
                    >
                        {category.name_localized || category.name}
                    </InternalLink>
                </h3>
            </div>
        );
    }
}
